import React from 'react';
import { getSvgPath } from '@wheeebo/polaris-svg';
import Marker from './Marker';
const PlaceMarker = ({ color, muiIcon, ...props }) => {
    return (React.createElement(Marker, { ...props, icon: muiIcon
            ? {
                path: getSvgPath(muiIcon),
                strokeOpacity: 0,
                fillColor: color,
                fillOpacity: 1,
                scale: 1.25,
                anchor: new google.maps.Point(11, 27),
            }
            : undefined }));
};
export default React.memo(PlaceMarker);
